/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import roleTypes from '../../constants/roleTypes';
import ArtistService from '../../services/artistService';
import ToastrService from '../../services/toastrService';

class ProfileTable extends Component {
    constructor(props, context) {
        super(props, context);
        this.select = this.select.bind(this);
    }    

    select(event, profile) {
        event.preventDefault();
        if(profile.Enabled) {
            this.props.selectAction(profile);
        }
        else {
            const toastrService = new ToastrService();
            toastrService.showError('', 'This profile has been disabled, click on the Enable button to enable it');
        }
    }

    render() {        
        if(this.props.profiles.length) {
            const containsMusician = this.props.profiles.find(p => p.RoleType === 'Musician') != null;
            const containsVenue = this.props.profiles.find(p => p.RoleType === 'Venue') != null;
            return (
                <React.Fragment>
                    <div className="signhead">
                        <h1 className="section-alt">Existing Profiles</h1>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div id="divProfileTable">
                                <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                                <div className="table-responsive">
                                    <table className="table table-striped table-results gig-listings">
                                        <thead>
                                            <tr>
                                                <th>ROLE TYPE</th>
                                                <th>USER NAME</th>
                                                <th>DISPLAY NAME</th>
                                                <th>GENRE/S</th>
                                                {
                                                    containsMusician ?
                                                    <React.Fragment>
                                                        <th>INSTRUMENT</th>
                                                        <th>EXPERTISE</th>
                                                    </React.Fragment>
                                                    : null
                                                }
                                                {
                                                    containsVenue ? <th>CAPACITY</th> : null
                                                }
                                                <th>&nbsp;</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.props.profiles.map(profile =>
                                                    <tr key={profile.ID} className="transition" style={!profile.Enabled ? {color: 'red'} : null}>
                                                        <td>{ArtistService.getRoleTypeFriendlyName(profile.RoleType)}</td>
                                                        <td>{profile.Username}</td>
                                                        <td>{profile.DisplayName}</td>
                                                        <td>{profile.Genres.join(', ')}</td>
                                                        {
                                                            containsMusician ?
                                                                <React.Fragment>
                                                                    <td>{profile.Instrument || '-'}</td>
                                                                    <td>{profile.Expertise || '-'}</td>
                                                                </React.Fragment>
                                                            : null
                                                        }
                                                        {
                                                            containsVenue ?
                                                                <td>{profile.Capacity || '-'}</td>
                                                            : null
                                                        }                                                    
                                                        <td>
                                                            <a href="#" className={`btn-simple transition ${!profile.Enabled ? 'disabled' : '' }`} style={!profile.Enabled ? {color: '#aaa'} : null} onClick={(e) => this.select(e, profile)}>Edit</a>
                                                        </td>
                                                        <td>
                                                            <a href="#" className="btn-simple transition" onClick={(e) => this.props.enableDisableAction(e, profile.ID, !profile.Enabled)}>{profile.Enabled ? 'Disable' : 'Enable'}</a>
                                                        </td>
                                                    </tr>
                                                )
                                            } 
                                        </tbody>
                                    </table>
                                </div>
                            </div>            
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        else {
            return null;
        }    
    }
}

ProfileTable.propTypes = {
    selectAction: PropTypes.func,
    profiles: PropTypes.array,
    enableDisableAction: PropTypes.func
};

export default ProfileTable;